import { Link, useRouterState } from "@tanstack/react-router";

/** Мобильный таб-бар S8: «маршрут · карта · домашки · вопросы». Только < md. */
const TABS = [
  { to: "/", label: "маршрут" },
  { to: "/map", label: "карта" },
  { to: "/homework", label: "домашки" },
  { to: "/questions", label: "вопросы" },
] as const;

export function TabBar() {
  const path = useRouterState({ select: (s) => s.location.pathname });
  return (
    <nav aria-label="разделы" className="fixed inset-x-0 bottom-0 z-20 grid grid-cols-4 border-t border-bd bg-bg md:hidden" data-testid="tabbar">
      {TABS.map((t) => {
        const active = t.to === "/" ? path === "/" || path.startsWith("/track") || path.startsWith("/step") : path.startsWith(t.to);
        return (
          <Link key={t.to} to={t.to} className={`flex min-h-[48px] items-center justify-center font-mono text-[11px] no-underline ${active ? "text-acc" : "text-mut"}`} style={{ borderTop: active ? "2px solid var(--acc)" : "2px solid transparent" }}>
            {t.label}
          </Link>
        );
      })}
    </nav>
  );
}
